module.exports = __webpack_public_path__ + "static/img/home8.b5075373.png";